import { useApiMutation } from '@/hooks/use-api-query';

export interface EditProfileValues {
  firstName: string;
  lastName: string;
  email: string;
}

export type PatchProfileVariables = Partial<EditProfileValues>;

export type PatchProfileResponse = {
  publicId: string;
  email: string | null;
  pendingEmail: string | null;
  firstName: string | null;
  lastName: string | null;
  emailVerified: boolean;
  emailPending: boolean;
};

export function usePatchProfileMutation() {
  return useApiMutation<PatchProfileResponse, PatchProfileVariables>(
    (vars) => ({
      path: '/auth/profile',
      init: {
        method: 'PATCH',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify(vars),
      },
      fallback: 'Failed to update profile',
    }),
  );
}

export function useVerifyProfileEmailMutation() {
  return useApiMutation<PatchProfileResponse, { code: string }>(
    ({ code }) => ({
      path: '/auth/profile/verify-email',
      init: {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ code }),
      },
      fallback: 'Network error',
    }),
  );
}

export function useResendProfileVerificationMutation() {
  return useApiMutation<{ ok: boolean }, void>(() => ({
    path: '/auth/profile/resend-verification',
    init: {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({}),
    },
    fallback: 'Failed to resend code',
  }));
}
